import { Col, Container, Row, Form } from "react-bootstrap";

import "./saved-contact.scss";
import { Button, IconArrowBackward, TextBox } from "@veneer/core";
import { AddNewContact } from "./add-new-contact";
import { apiPost } from "../../../../services/service";
import {
  POST_FAVOURITES,
  POST_PROFILE_PAGE_LOAD,
  POST_SELECTED_CONTACT,
} from "../../../../services";
import { useEffect, useState } from "react";
import Loader from "../../shared-components/loader/loader";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import { allOptionForDropdown } from "../../../../utils";
export const SavedContact = (props: any) => {
  const [progress, setProgress] = useState(false);
  const [mySavedContacts, setMySavedContacts] = useState<any>([]);
  const [allContacts, setAllContacts] = useState<any>([]);
  const [allContactRes, setAllContactRes] = useState<any>([]);
  const [selectedContact, setSelectedContact] = useState<string[]>([]);
  const [searchValue, setSearchValue] = useState<string>();
  const [selectedRmvContact, setSelectedRmvContact] = useState<string[]>([]);
  const [showEditcase, setShowEditcase] = useState<boolean>(false);
  const [selectedContactDetails, setSelectedContactDetails] =
    useState<string>();
  const [companyList, setCompanyList] = useState<any>();  
  const [listOfAccountjson, setListOfAccountjson] = useState<any>();

  const [popupTilte, setPopupTitle] = useState<string>("");
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleCallBack = (title: string) => {
    setPopupTitle(title);
    setOpen(true);
  };

  const popupHeader = () => {
    return (
      <p className="popup-header">
        <img
          src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
          alt=""
          style={{ height: "46px", width: "auto" }}
        />
        <span>{popupTilte}</span>
      </p>
    );
  };

  const fetchdata = async () => {
    let payload = {
      tabid: "savedContacts",
    };
    try {
      setProgress(true);
      let pageLoad = await apiPost(POST_PROFILE_PAGE_LOAD, payload);
      if (pageLoad.data) {
        let data = pageLoad.data;
        let CompanyList = allOptionForDropdown(JSON.parse(data?.CompanyList))
        setCompanyList([{ label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "" },...CompanyList])
        setAllContactRes(JSON.parse(data.AllContacts));
        let allContacts = allOptionForDropdown(JSON.parse(data.AllContacts));
        setAllContacts(allContacts);
        let mySavedContacts = allOptionForDropdown(
          JSON.parse(data.MySavedContacts)
        );
        setMySavedContacts(mySavedContacts);
        setProgress(false);
      } else {
        //toast.error("Session Expired ! refresh the page");
        setProgress(false);
      }
    } catch (error) {
      setProgress(false);
    }
  };

  const allOptionForDropdown = (data: any) => {
    return data
      ? data.map(({ Value, Key }: any) => ({
        label: Value,
        value: Key,
      }))
      : [];
  };

  const searchContact = (query: string, contacts: any) => {
    return contacts.filter(
      (contact: any) =>
        contact.Value.toLowerCase().includes(query.toLowerCase()) ||
        contact.email.toLowerCase().includes(query.toLowerCase())
    );
  };

  const companyHandler = (event: any) => {
    setSelectedContact(
      Array.from(event.target.selectedOptions, (option: any) => option.value)
    );
  };
  const addToList = () => {
    let addToContacts = selectedContact.join(";");
    if (addToContacts === "") {
      toast.error(t('HPI.ErrorMessage.PleaseSelectAnyContactFromCompany contacts',{defaultValue:'Please select any contact from Company contacts'}));
      return false;
    }
    addTContactApi(addToContacts, "ON");
  };

  const removeContactsHandler = (event: any) => {
    setSelectedRmvContact(
      Array.from(event.target.selectedOptions, (option: any) => option.value)
    );
  };
  const removeToList = () => {
    let addToContacts = selectedRmvContact.join(";");
    if (addToContacts === "") {
      toast.error(t('HPI.ErrorMessage.PleaseSelectAnyContactFromMysavedcontacts',{defaultValue:'Please select any contact from My saved contacts'}));
      return false;
    }
    addTContactApi(addToContacts, "OFF");
  };
  const addTContactApi = async (addToContacts: string, state: string) => {
    try {
      setProgress(true);
      let payload = {
        key: "favourite_contacts",
        state: state,
        id: `${addToContacts};`,
        
        
      };
      let res = await apiPost(POST_FAVOURITES, payload);
      if (res.data) {
        toast.success(res?.data?.SuccessMessage);
        setSelectedContact([]);
        setSelectedRmvContact([]);
        fetchdata();
        setShowEditcase(false);
        setProgress(false);
      } else {
        // toast.error("Session Expired ! refresh the page");
        setSelectedContact([]);
        setSelectedRmvContact([]);
        fetchdata();
        setShowEditcase(false);
        setProgress(false);
      }
    } catch (error) {
      setSelectedContact([]);
      setSelectedRmvContact([]);
      fetchdata();
      setProgress(false);
    }
  };
  useEffect(() => {
    fetchdata();
  }, []);

  const handleSearch = (v: any) => {
    setSearchValue(v);
    let filteropt = searchContact(v, allContactRes);
    let newoption = allOptionForDropdown(filteropt);
    setAllContacts(newoption);
  };

  const editContact = async () => {
    if (selectedRmvContact?.length <= 0) {
      toast.error(t('HPI.ErrorMessage.PleaseSelectAnyContactFromMysavedcontacts',{defaultValue:'Please select any contact from My saved contacts'}));
      return false;
    }
    setShowEditcase(true);
    try {
      let payload = {
        selectedContactID: selectedRmvContact?.[0],
      };
      let res = await apiPost(POST_SELECTED_CONTACT, payload);
      if (res.data) {
        setSelectedContactDetails(JSON.parse(res?.data?.selectedContact));
      } else {
        toast.error(res?.message);
        setShowEditcase(false);
      }
    } catch (error) {
      setShowEditcase(false);
    }
  };
  const handleEditcase = () => {
    setShowEditcase(false);
  };

  return (
    <div className="saved-contact">
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}

      <div className="tooltip-container mb-4">
        <div className="label-container ">
          <label className="body-regular">
            {t("HPI.Profilepage.savedContacts.contactinfo", {
              defaultValue:
                "Frequently used contacts can be saved to your profile to speed up the case submittal process.",
            })}
            {/* <span className="error">*</span> */}
          </label>

          <span className="supporting-text" >
            <HelpModalPopup
              align={"start"}
              id={"modal-popup"}
              show={open}
              onClose={() => setOpen(false)}
              title={popupHeader()}
              callback={() => handleCallBack(t("HPI.Profilepage.CompanyProfileuserModal.header",{defaultValue:'Saved contact'}))}
            >
              <p dangerouslySetInnerHTML={{__html:t("HPI.Profilepage.CompanyProfileuserModal.body", {defaultValue:"Save frequently used contacts to your own list to help speed up the process when creating cases.<br><br>The names on this list are only used as contact information and does not effect existing accounts or create new accounts. To add a new user to an account, use the features under the ‘Administration’ tab."})}}>
              </p>
            </HelpModalPopup>
          </span>

        </div>
        </div>





      <Container>
        <Row className="align-item">
          <Col col={12} md={5} className="dropdown-container">
            <h5 className="subtitle-regular">
              {t("HPI.Profilepage.savedContacts.savedcontact", {
                defaultValue: "My saved contacts",
              })}
            </h5>
            <div className="textarea">
              <Form.Select
                multiple
                size="lg"
                value={selectedRmvContact}
                onChange={removeContactsHandler}
              >
                {mySavedContacts &&
                  mySavedContacts.map((item: any) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </Form.Select>
            </div>

            <div className="bottom-content">
              <p className="bottom-content">
                {t("HPI.Profilepage.savedContacts.EditContactlist", {
                  defaultValue:
                    'Choose a name and select "Edit" to make any changes and save information to your contact list.',
                })}
              </p>

              <Button className="w-100" onClick={editContact}>
                {" "}
                {t("HPI.Editcontact", { defaultValue: "Edit contact " })}
              </Button>
              <Button onClick={removeToList}>
                {t("HPI.Removesavedcontact", {
                  defaultValue: "Remove saved contact",
                })}
              </Button>
            </div>
          </Col>
          <Col col={12} md={2}>
            <Button onClick={addToList}>
              <IconArrowBackward size={15} color={"#fff"} className="mr-1" />{" "}
              {t("HPI.btnAddtolist", { defaultValue: "Add to list" })}
            </Button>
          </Col>

          <Col col={12} md={5} className="dropdown-container">
            <h5 className="subtitle-regular">
              {t("HPI.Profilepage.savedContacts.Companycontact", {
                defaultValue: "Company contacts",
              })}
            </h5>
            <div className="textarea">
              <Form.Select
                multiple
                size="lg"
                name="allCompany"
                value={selectedContact}
                onChange={companyHandler}
              >
                {allContacts &&
                  allContacts.map((item: any) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </Form.Select>
            </div>

            <div className="bottom-content">
              <p className="body-regular">
                {t("HPI.Profilepage.savedContacts.nameandselect", {
                  defaultValue:
                    'Choose a name and select "Add to list" to place a contact in your saved list. Search by name or email below.',
                })}
              </p>

              <TextBox
                label={t("HPI.Profilepage.savedContacts.search", {
                  defaultValue: "Search by name or email",
                })}
                separateLabel
                value={searchValue}
                onChange={handleSearch}
              />

              <p className="caption-small m-1 w-100">
                {t("HPI.Profilepage.savedContacts.example", {
                  defaultValue:
                    'Example: "John", "John Doe", "john.doe@company.com"',
                })}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      {showEditcase && (
        <AddNewContact
          companyList ={companyList?companyList:[]}
          title='Edit contact'
          btnName={t('HPI.Updatecontact',{defaultValue:'Update contact'})}
          data={selectedContactDetails}
          handleEditcase={handleEditcase}
          fetchdata={fetchdata}
          contactid={selectedRmvContact?.[0]}
        />
      )}

      <AddNewContact fetchdata={fetchdata}  companyList ={companyList?companyList:[]}

 />
    </div>
  );
};
